import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OfertaService {

  constructor(private http: HttpClient) { }
  listarOfertas():Observable<any>{
    const params = new HttpParams().set('funcion', 'listarOfertas');
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }
  listarOfertasVigentes():Observable<any>{
    const params = new HttpParams().set('funcion', 'listarOfertasVigentes');
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }

  obtenerOferta(id: string):Observable<any>{
    const params = new HttpParams().set('funcion', 'obtenerOferta').set('id',id);
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }

  guardarOferta(fecha: string, urlMini: any, urlPdf: any,id:string):Observable<any> {
    const formData = new FormData();
    formData.set('urlMini',urlMini);
    formData.set('urlPdf',urlPdf);
    const params = new HttpParams().set('funcion', 'guardarOferta').set('id',id).set('fecha',fecha);
    return this.http.post(`${environment.url.gestionSoporte}`,formData, { params });
  }

  eliminarOferta(id: string):Observable<any> {
    const params = new HttpParams().set('funcion', 'eliminarOferta').set('id',id);
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }

  desAcOferta(id: string, estado: string):Observable<any> {
    const params = new HttpParams().set('funcion', 'desActOferta').set('id',id).set('estado',estado);
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }
}
